import { Container, Grid, Link } from '@mui/material'
import React from 'react'
import { Text } from '../Text'
import siteLogo from '../../images/logo.png'
export const Footer = () => {
  return (
    <Container maxWidth="xl" className='py-4'>
        <Grid container>
            <Grid xs={12} sm={4}>
                <Link href="/">
                    <img src={siteLogo} className="img-fluid w-100" style={{maxWidth: 170}} />
                </Link>
            </Grid>
            <Grid xs={12} sm={8} className="text-right mt-4 mt-sm-0">
                <Text mb="0">© PulsePrinter 2023 All Rights Reserved</Text>
            </Grid>
        </Grid>
    </Container>
  )
}
